import { component } from 'picoapp';
import { waitUntil } from 'utils/ready';
import loadScript from 'utils/load-script';

export default component(async (node) => {
  const { key } = node.dataset;

  const url = new URL('https://static.zdassets.com/ekr/snippet.js');
  url.searchParams.append('key', key);

  const init = async () => {
    await loadScript(url.toString(), {
      id: 'ze-snippet',
    });

    sessionStorage.setItem('zendesk', 'true');
    node.hidden = true;

    await waitUntil(window.zE, 200);

    setTimeout(() => {
      window.zE('webWidget', 'setLocale', Shopify.locale);

      window.zE('webWidget:on', 'chat:unreadMessages', () => {
        window.zE('webWidget', 'open');
      });
    }, 200);
  };

  if (sessionStorage.getItem('zendesk')) {
    init();
  }

  node.addEventListener('click', async () => {
    await init();
    window.zE('webWidget', 'open');
  });
});
